module.exports = __webpack_public_path__ + "img/godot.b3a32142.png";